import React from "react";
import "../studyabroad/studyAbroad.css";
import InquiryForm from "../InquiryForm";

const StudyInUSA = () => {
  return (
    <div className="study-abroad-container">

      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>Study Abroad in U.S.A</h1>
          <p>
            The United States is home to thousands of accredited colleges and 
            universities renowned for academic excellence, flexibility, and 
            global recognition. Around 30% of all international students worldwide 
            choose to study in the USA, making it one of the most diverse and 
            culturally enriching destinations for higher education.
          </p>
        </div>

        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1508433957232-3107f5fd5995"
            alt="Study in USA"
          />
        </div>
      </section>

      {/* INFO SECTION */}
      <section className="info-section">

        <div className="info-card">
          <h2>Flexible Education System</h2>
          <p>
            The US education system offers unmatched flexibility. Students can 
            choose subjects from a wide variety of topics and specialize in 
            their preferred area without unnecessary coursework. Many courses 
            are offered multiple times throughout the academic year.
          </p>
        </div>

        <div className="info-card">
          <h2>Optional Practical Training (OPT)</h2>
          <p>
            After completing a degree, international students are eligible 
            to work in the US for up to one year through Optional Practical 
            Training (OPT). Many students transition to full-time employment 
            through H1-B visa sponsorship.
          </p>
        </div>

        <div className="info-card">
          <h2>Research & Funding Opportunities</h2>
          <p>
            The US is ideal for MS and PhD students. Many universities offer 
            research grants, tuition waivers, and stipends funded by federal 
            agencies or multinational corporations, allowing students to 
            earn while they learn.
          </p>
        </div>

        <div className="info-card">
          <h2>Global Recognition</h2>
          <p>
            American degrees are valued and recognized worldwide. With over 
            3000 accredited institutions, US universities consistently rank 
            among the top globally.
          </p>
        </div>

        <div className="info-card">
          <h2>Part-Time Work Opportunities</h2>
          <p>
            International students can work up to 20 hours per week during 
            academic sessions and 40 hours per week during vacations, 
            helping them manage living expenses and gain experience.
          </p>
        </div>

        <div className="info-card">
          <h2>Student Support & Infrastructure</h2>
          <p>
            US campuses provide state-of-the-art infrastructure, 24/7 libraries, 
            research labs, career centers, counseling services, and campus 
            facilities that support both personal and professional growth.
          </p>
        </div>

      </section>

      {/* WHY STUDY SECTION */}
      <section className="why-section">
        <h2>Why Study in USA?</h2>
        <ul>
          <li>Worldwide recognition of American degrees</li>
          <li>Wide range of undergraduate and graduate programs</li>
          <li>Access to cutting-edge research and innovation</li>
          <li>Financial assistance, scholarships & fee waivers</li>
          <li>Multicultural and diverse learning environment</li>
          <li>Strong career prospects after graduation</li>
          <li>Part-time work allowed during study</li>
        </ul>
      </section>

      {/* INTAKE SECTION */}
      <section className="intake-section">
        <h2>Intake</h2>
        <p>
          The United States has three major intakes:
          <br /><br />
          <strong>Fall (August/September)</strong> – Most popular intake (70% students)  
          <br />
          <strong>Spring (January/February/March)</strong>  
          <br />
          <strong>Summer (May/June)</strong> – Less commonly chosen  
          <br /><br />
          There is no difference in the quality of education or job opportunities 
          between Fall and Spring intakes.
        </p>
      </section>

      {/* INQUIRY FORM */}
      <InquiryForm title="Inquire About Study in USA" />

    </div>
  );
};

export default StudyInUSA;
